import React, { useEffect, useState } from "react";
import general from "../../general";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { NavLink } from "../../lib/Navigation";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import { CSSTransition } from "react-transition-group";
import { activityUrl } from "../../config";
import { useLogin } from "../../lib/LoginContext";
import { splitStr } from "../../utils/commonFunc";
import { sessionLocal } from "../util/storage";
import useUrlState from "@ahooksjs/use-url-state";
import { useHistory } from "react-router-dom";

const devices = {
  0: "双",
  1: "安卓",
  2: "苹果",
};

const status = {
  0: "verify",
  "-1": "invalid",
  1: "complete",
  2: "reject",
  3: "reviewed",
};

const Operates = (props) => {
  const [trade, setTrade] = useState({});
  useEffect(() => {
    setTrade(props.trade);
  }, [props]);

  return (
    <div className="trade-operates">
      <Link to="/service">
        <img
          style={{ width: "20px" }}
          src="/resources/four-three/trade/contact.png"
          alt=""
        />
      </Link>

      <CopyToClipboard
        text={
          window.location.href +
          "&agent=" +
          localStorage.getItem("agent") +
          "&brand=" +
          JSON.parse(localStorage.getItem("app"))?.brand
        }
        onCopy={() => Dialog.info("链接已复制")}
      >
        <img
          style={{ width: "20px", marginLeft: "7px" }}
          src="/resources/four-three/trade/share.png"
          alt=""
        />
      </CopyToClipboard>
    </div>
  );
};

export default (props) => {
  const history = useHistory();
  const [params] = useUrlState();

  const { setShowLogin } = useLogin();

  const [trade, setTrade] = useState({});
  const [game, seGame] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    props.setOperate(
      <Operates trade={trade ? trade : { trade_id: props.id }} />,
    );
  }, [props.id, trade]);

  const load = () => {
    if (loading) {
      return;
    }

    Dialog.loading();
    general.axios
      .post("/v3/user/trade/getTradeDetail", { trade_id: props.query.id })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setLoading(true);

          setTrade({
            ...data,
            is_collected: parseInt(data.is_collected),
          });
          seGame(data.game_info);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  useEffect(() => {
    load();
  }, []);

  const [confirm, setConfirm] = useState();
  const [confirmed, setConfirmed] = useState();

  const favorite = () => {
    if (!general.isLogin()) {
      setShowLogin(true);
      return;
    }

    Dialog.loading();
    general.axios
      .post(
        trade.is_collected ? "/v3/cancelCollectTrade" : "/v3/collectTrade",
        {
          id: trade.trade_id,
        },
      )
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setTrade({ ...trade, is_collected: !trade.is_collected });
          Dialog.info("操作成功");
        }
      })
      .catch((err) => {
        Dialog.error("collectTrade " + err.message);
      });
  };

  useEffect(() => {
    if (confirm) {
      // iOS Safari 兼容处理：同时设置 html 和 body
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    }
    // 清理函数：组件卸载时恢复样式
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    };
  }, [confirm, props.active]);

  function isAndroidBrowser() {
    return /Android/i.test(navigator.userAgent);
  }

  function downloadAndroid() {
    Dialog.info(
      "下载APP进行购买",
      () => {
        let brand = params.brand || "9917";
        /*
        id == 152 ||
        id == 107266 ||
        id == 107268 ||
        id == 102583 ||
        id == 101828 ||
        id == 108330 ||
        id == 107982 ||
        id == 107546 ||
        id == 107992
        */
        let gameId =
          brand == "9917"
            ? 152
            : brand == "zc"
              ? 107266
              : brand == "97"
                ? 107268
                : brand == "hiwan"
                  ? 102583
                  : brand == "btwan"
                    ? 101828
                    : brand == "fw"
                      ? 108330
                      : 152;
        let jumpUrl = `https://and-new.9917.cn/?gameId=${gameId}&agent=${params.agent}`;

        if (brand == "97") {
          jumpUrl = `http://app.97yxh.com/?a=${params.agent || "4ewu"}`;
        } else if (brand == "zc") {
          jumpUrl = `http://app.ppxiong.vip/?a=${params.agent || "hda4"}`;
        }

        window.location.href = jumpUrl;
      },
      1,
    );
  }

  // 购买0元小号
  const [zeroAccountDialog, setZeroAccountDialog] = useState(false);
  const buyZeroAccount = () => {
    if (!general.isLogin()) {
      setShowLogin(true);
      return;
    }

    let formData = new FormData();
    formData.append("username", localStorage.getItem("username"));
    formData.append("token", localStorage.getItem("token"));
    formData.append("id", trade.trade_id);
    formData.append("xh_id", 0);
    formData.append("type", "alipay");
    formData.append("pay_source_type", 2);

    general.axios
      .post(
        `/home/trade/pay?username=${localStorage.getItem("username")}&token=${localStorage.getItem("token")}`,
        formData,
      )
      .then((res) => {
        console.log("0元购小号----", res);

        if (res.data.status === 1) {
          setZeroAccountDialog(false);
          Dialog.info(
            "购买成功",
            () => {
              history.replace("/screen-trade?page=2&tradeType=1");
            },
            1,
          );
        } else {
          if (res.data.status === 2) {
            Dialog.info(res.data.msg, () => {
              location.reload();
            });
            return;
          }

          if (res.data.status === 11) {
            Dialog.affirm(
              "温馨提示",
              "实名认证通过的账号才能购买0元小号",
              () => {
                Dialog.close();
                setZeroAccountDialog(false);
              },
              () => {
                history.push("/user/realname");
              },
              {
                close: "取消购买",
                affirm: "立即实名",
              },
            );
            return;
          }

          Dialog.error(res.data.info);
        }
      })
      .catch((err) => {
        Dialog.error("buyZeroAccount " + err.message);
      });
  };

  return (
    <>
      {loading && (
        <div
          className="trade-detail"
          style={{
            padding:
              trade.check_status == 2 || trade.check_status == 3
                ? "9px 14px calc(env(safe-area-inset-bottom) + 47.5px)"
                : "9px 14px calc(env(safe-area-inset-bottom) + 9px)",
          }}
        >
          <Link
            to={"/game?mid=" + trade.game_id}
            className="trade-box trade-game"
          >
            <div className="icon">
              <Image src={game.game_image?.thumb} />
            </div>
            <div className="data">
              <div className="name">
                {game.game_name_main || game.game_name}
              </div>

              <div className="desc">
                <span>{splitStr(game.versioncode)} </span>

                {game.game_name_branch && (
                  <div className="branch">· {game.game_name_branch}</div>
                )}
              </div>
            </div>
            <div className="opt">
              <div className="btn">下载</div>
            </div>
          </Link>

          <div className="trade-title">
            基本信息
            <span className="trade-title-device">
              （适用于{devices[trade.game_device_type]}端）
            </span>
          </div>
          <div className="trade-box">
            <div className="trade-content">
              <div className="item">
                <div className="item-content">
                  <div className="item-title">游戏区服</div>
                  {trade.server_name}
                </div>
              </div>

              <div className="item">
                <div className="item-content">
                  <div className="item-title">小号</div>
                  {trade.xh_alias}
                </div>
              </div>

              <div className="item">
                <div className="item-content">
                  <div className="item-title">实际充值</div>
                  <div>{trade.xh_recharge_money}元</div>
                  <img
                    src="/resources/four-three/trade/illustrate.png"
                    alt=""
                    onClick={() => {
                      document.body.style.overflow = "hidden";

                      Dialog.tips(
                        "说明",
                        <div className="box-tips-content">
                          <p>实际充值金额是当前小号所有区服</p>
                          <p>充值总和</p>
                        </div>,
                        () => {
                          document.body.style.overflow = "auto";
                        },
                      );
                    }}
                  />
                </div>
              </div>

              <div className="item">
                <div className="item-content">
                  <div className="item-title">出售价格</div>
                  <span className="item-price">￥{trade.sell_price}</span>
                </div>

                {trade.sell_time && (
                  <div className="item-other">
                    {dayjs.unix(trade.sell_time).format("YYYY-MM-DD HH:mm:ss")}
                    上架
                  </div>
                )}
              </div>
            </div>

            <div className="trade-state">
              <img
                src={"/resources/trade/" + status[trade.check_status] + ".png"}
                alt=""
              />
            </div>
          </div>

          {trade.check_status == 2 && trade?.reject_content ? (
            <>
              <div className="trade-title">驳回原因</div>
              <div
                className="trade-box"
                style={{ backgroundColor: " #FEF1F1" }}
              >
                <div
                  className="trade-content err"
                  style={{ color: "#ff3c3c" }}
                  dangerouslySetInnerHTML={{
                    __html: trade?.reject_content?.replace(
                      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
                      "$1<br>$2",
                    ),
                  }}
                />
              </div>
            </>
          ) : null}

          <div className="trade-title">{trade.title}</div>

          <div
            className="trade-box trade-product-desc"
            dangerouslySetInnerHTML={{
              __html: trade.content
                ? trade.content.replace(
                    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
                    "$1<br>$2",
                  )
                : "该卖家很懒，未填写任何描述哦~",
            }}
          />

          <div className="trade-title">游戏截图</div>

          <div className="trade-imgs">
            {trade.game_screenshots?.map((img, index, imgs) => (
              <Link
                key={index}
                to={
                  "/img?imgs=" +
                  imgs.map((item) => item.source) +
                  "&img=" +
                  index
                }
                className="item"
              >
                <Image src={img.thumb} alt="" />
              </Link>
            ))}
          </div>

          {trade.check_status == 2 || trade.check_status == 3 ? (
            <div className="trade-operate">
              {trade.is_collected ? (
                <div>
                  <img
                    src="/resources/four-three/trade/collected.png"
                    alt=""
                    className="trade-collect"
                    onClick={favorite}
                  />
                  <div className="trade-collect-text">已收藏</div>
                </div>
              ) : (
                <div>
                  <img
                    src="/resources/four-three/trade/collect.png"
                    alt=""
                    className="trade-collect"
                    onClick={favorite}
                  />
                  <div className="trade-collect-text">收藏</div>
                </div>
              )}

              {trade.check_status == 2 ? (
                <Link
                  to="/screen-trade?page=1&tab=2&secondTrade=1"
                  className="btn"
                  onClick={() => {
                    if (isAndroidBrowser()) {
                      downloadAndroid();

                      return;
                    }
                    sessionLocal.set("tradeInfo", {
                      ...trade,
                      game_id: game.id,
                      game_imgs: trade.game_screenshots.map(
                        (item) => item.thumb,
                      ),
                      isUpdate: 1,
                    });
                  }}
                >
                  重新出售
                </Link>
              ) : trade.check_status == 3 ? (
                <div
                  className="btn"
                  onClick={() => {
                    if (isAndroidBrowser()) {
                      downloadAndroid();

                      return;
                    }

                    if (!general.isLogin()) {
                      setShowLogin(true);
                      return;
                    }
                    if (
                      trade.seller_username ==
                        localStorage.getItem("username") ||
                      trade.is_same_auth
                    ) {
                      Dialog.info("不能购买自己的小号");
                      return;
                    }
                    setConfirm(true);

                    document.body.style.overflow = "hidden";
                  }}
                >
                  立即购买
                </div>
              ) : null}
            </div>
          ) : null}

          <CSSTransition in={confirm} timeout={250} unmountOnExit={true}>
            <div className="trade-confirm">
              <div className="container">
                <div className="head">
                  <div className="title">交易须知</div>
                  <img
                    style={{ width: "20px", height: "20px" }}
                    src="/resources/four-three/trade/close.png"
                    alt=""
                    onClick={() => {
                      setConfirm(false);

                      document.body.style.overflow = "auto";
                    }}
                  />
                </div>
                <div className="main">
                  <div className="process">
                    <ul className="process-list">
                      <li className="process-num">1</li>
                      <li className="process-line"></li>
                      <li className="process-num">2</li>
                      <li className="process-line"></li>
                      <li className="process-num">3</li>
                      <li className="process-line"></li>
                      <li className="process-num">4</li>
                    </ul>
                    <ul className="process-list">
                      <li className="process-text">选择商品</li>
                      <li className="process-text">购买商品</li>
                      <li className="process-text">下载游戏</li>
                      <li className="process-text">登录游戏</li>
                    </ul>
                  </div>

                  <div className="title">买家须知</div>
                  <div className="body" style={{ maxHeight: "40vh" }}>
                    <p>
                      角色描述、截图已通过官方核验。因时间因素造成的变化(排行榜、称号、装备到期等)，不视为信息失实。
                    </p>
                    <p>
                      交易后角色直接转入购买玩家的平台账号，登录游戏-点击悬浮窗-切换小号即可。
                    </p>
                    <p>
                      交易过程仅限小号转移，不涉及账号交易或换绑操作，无需担心购买的号被找回。
                    </p>
                    <p>
                      购买时显示累计金额为该小号在该游戏同一小号下多个区服的角色所有累计充值。
                    </p>
                    <p>
                      购买的小号如上一号主领取了游戏礼包和代金券的话，购买后同一类型游戏礼包和代金券，无法再次领取。
                    </p>
                    <p>交易完成后，不支持退货。</p>
                    <p>交易完成的小号超过72小时后才可重新上架交易。</p>
                    <p>所购买的小号不支持转游/转区操作。</p>
                    <p>
                      买家须知：因买家购买过程中操作失误产生的一切损失，由买家自行承担，平台概不负责。
                    </p>
                  </div>
                </div>

                <div className="operate">
                  <div className="input" onClick={() => setConfirmed(true)}>
                    <img
                      src={
                        confirmed
                          ? "/resources/four-three/trade/radio-selected.png"
                          : "/resources/four-three/trade/radio.png"
                      }
                      alt=""
                    />
                    我已阅读
                  </div>

                  {trade.sell_price > 0 ? (
                    <NavLink
                      className={"buy" + (!confirmed ? " disable" : "")}
                      to={`${activityUrl}/trade?id=${trade.trade_id}`}
                      onClick={(e) => {
                        if (!confirmed) {
                          Dialog.info("请先阅读并勾选交易须知");
                          e.preventDefault();
                          e.stopPropagation();
                          return;
                        }
                        setConfirm(false);
                        setConfirmed(false);
                        document.body.style.overflow = "auto";
                      }}
                      iframe={{ title: "购买" }}
                    >
                      确认购买
                    </NavLink>
                  ) : (
                    <div
                      className={"buy" + (!confirmed ? " disable" : "")}
                      onClick={(e) => {
                        if (!confirmed) {
                          Dialog.info("请先阅读并勾选交易须知");
                          e.preventDefault();
                          e.stopPropagation();
                          return;
                        }
                        setConfirm(false);
                        setConfirmed(false);
                        document.body.style.overflow = "auto";

                        setZeroAccountDialog(true);
                      }}
                    >
                      确认购买
                    </div>
                  )}
                </div>
              </div>
            </div>
          </CSSTransition>

          <CSSTransition
            in={zeroAccountDialog}
            timeout={250}
            unmountOnExit={true}
          >
            <div className="trade-zero-account-dialog">
              <div className="container">
                <div className="title">温馨提示</div>
                <div className="content">您确定购买当前小号吗？</div>

                <div className="operate">
                  <div
                    className="btn cancel-buy"
                    onClick={() => setZeroAccountDialog(false)}
                  >
                    暂不购买
                  </div>
                  <div className="btn confirm-buy" onClick={buyZeroAccount}>
                    立即购买
                  </div>
                </div>
              </div>
            </div>
          </CSSTransition>
        </div>
      )}
    </>
  );
};
